export class RequestToJoinGroupError {
  public static readonly type = '[Browse/Groups] RequestToJoinGroupError';
  constructor(public readonly error: Error) {}
}
